<template>
  <v-btn
    type="submit"
    class="white--text"
    :style="[
      {
        padding: `2px 16px`,
        backgroundColor: '#ac832d',
        borderRadius: '24px',
        boxShadow: 'none',
      },
      $breakpoints.mdAndUp && {
        padding: `${$getScaledCssValue('8px')} ${$getScaledCssValue('38px')}`,
        borderRadius: $getScaledCssValue('7px'),
      },
    ]"
  >
    <!--{{ buttonText }}-->
    <div
      :class="{
        'text-p4 white--text': true,
        'font-weight-light': $breakpoints.smAndDown,
      }"
      :style="[
        { textTransform: 'none' },
        $breakpoints.mdAndUp && { textTransform: 'uppercase' },
      ]"
    >
      {{ $t("SearchMsg") }}
    </div>
  </v-btn>
</template>

<script>
export default {};
</script>

<style scoped></style>
